import Stencil from "../stencil";
import StencilHTMLElement from "./stencil-element";

class SwiperSlider extends StencilHTMLElement {
  name = "SwiperSlider";

  instance;
  #options;

  constructor() {
    super();
  }

  get options() {
    return this.#options;
  }

  set options(value) {
    this.#options = value;
    this.init();
  }

  connectedCallback() {
    if(this.getAttribute("options") || this.#options) {
      this.#options = this.#options || JSON.parse(this.getAttribute("options"));
      this.init();
    }
  }

  init() {
    if(this.instance) {
      console.log(this.logPrefix, 'Destroyed existing instance');
      this.instance.destroy();
    }
    // @ts-ignore
    this.instance = new window.Swiper(this.firstElementChild, this.#options);
    console.log(this.logPrefix, `Initialised ${this.id}`, this.firstElementChild, this.instance, this.#options);
  }
}

export default SwiperSlider;